
import React from "react";
const CleaningOverview = () => {
    return (
        <div className="container">
            <div className="leftSide">
                <h1>Jasa Pembersihan Rumah dan Properti </h1>

                <p>
                ChiFlo <span className="orange_text">jasa cleaning service dan bersih-bersih rumah dengan misi utama memberikan layanan jasa bersih yang murah dan kompeten dalam bidangnya.</span> Kami percaya ruangan yang bersih dan segar bisa menciptakan kebahagiaan bagi penghuninya. Untuk menciptakan hal tersebut, <span className="orange_text">kami fokus dalam menyediakan fitur online booking, customer support yang responsif dan tukang bersih yang berkualitas.</span> Ayo pesan layanan ChiFlo dan rileks, Kami siap hadir membersihkan rumah, kantor, dan properti anda lainnya.
                </p>
            </div>
            
            <div className="rightSide col-5">
                <img src="/CleanOverview.png" alt="icon" />
            </div>

            <div className="line">
                    <img src="/line.png" alt="/" />
            </div>
        </div>
    )
}

export default CleaningOverview;